import { ScreenSize } from 'hooks/useScreenSize';

export const CALENDAR_ROW_SIZE = 7;

export const DESKTOP_LAYOUT_BREAKPOINT = 836;

export const CALENDAR_COLUMNS_BY_SCREEN: Record<string, number> = {
  small: 4,
  mediumSmall: 5,
  medium: 6,
  desktop: 7,
};

export const GRID_COLS_CLASS: Record<number, string> = {
  3: 'tw-grid-cols-3',
  4: 'tw-grid-cols-4',
  5: 'tw-grid-cols-5',
  6: 'tw-grid-cols-6',
  7: 'tw-grid-cols-7',
};

export const getCalendarColumns = (screenSize: ScreenSize) => {
  if (screenSize <= ScreenSize.small) return CALENDAR_COLUMNS_BY_SCREEN.small;
  if (screenSize <= ScreenSize.mediumSmall) return CALENDAR_COLUMNS_BY_SCREEN.mediumSmall;
  if (screenSize <= ScreenSize.medium) return CALENDAR_COLUMNS_BY_SCREEN.medium;
  return CALENDAR_COLUMNS_BY_SCREEN.desktop;
};

export const getDesktopCalendarColumns = (windowWidth: number): number => {
  if (windowWidth >= 1280) return 7;
  if (windowWidth >= 1170) return 6;
  if (windowWidth >= 1058) return 5;
  if (windowWidth >= 920) return 4;
  return 3;
};
